<!-- for loading data that cannot be soft deleted -->
<template>
	<v-autocomplete
		:error="errorBorder"
		:error-messages="$props.error"
		:items="options"
		:label="label"
		:readonly="readonly"
		:disabled="disabled"
		:hide-details="hideDetails"
		:no-data-text="$t('labels.noData')"
		item-text="label"
		item-value="value"
		v-model="selectedValue"
	>
		<template #prepend-item>
			<slot name="firstItem"></slot>
		</template>
		<template #prepend>
			<slot name="prepend"></slot>
		</template>
	</v-autocomplete>
</template>

<script>
export default {
	name: 'Dropdown3',
	props: {
		readonly: Boolean,
		disabled: Boolean,
		value: [String, Number, Boolean],
		ajax: Boolean,
		data: [Array, String],
		label: String,
		apiCallOnSelect: Boolean,
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			endpoint: '',
			selectedValue: null,
			options: [],
			ajaxLoaded: false,
			protected: null,
			latestValue: null,
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},

	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal != this.selectedValue) {
					this.setValue(newVal);
				}
			}
		},
		selectedValue: function (val) {
			if (val != this.$props.value) {
				if (val != null) {
					if (val != this.$props.value) {
						this.$nextTick(() => {
							this.$emit('input', val);
						});
					}
				} else {
					this.$nextTick(() => {
						this.$emit('input', null);
					});
				}
				this.$nextTick(() => {
					this.callChange();
				});
			}
		},
	},
	methods: {
		callChange() {
			this.$emit('changes');
		},
		setValue(newVal) {
			this.selectedValue = newVal;
		},
	},
	created() {
		var vm = this;
		if (this.$props.ajax) {
			this.$APICall(
				'get',
				'select/' + this.$props.data,
				{},
				(data, success) => {
					if (success) {
						vm.options = data;
					}
				},
				false
			);
		}
	},
	mounted() {
		this.setValue(this.$props.value);
	},
};
</script>

<style scoped>
.simple {
	padding: 0px;
	margin: 0px;
}
</style>
